export enum Recommended {
    compact,
    consistent,
    scattered,
    freeDays,
    latestStart,
    earliestEnd
}
